module["exports"] = [
  "福建省",
  "台灣省"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/zh_TW/address/state.js
// module id = 3730
// module chunks = 1610